import React from 'react';
import { Button } from '@perch-labs/shrike';
import { copyFor } from 'config';

const getCopy = copyFor('settings.personalInformation');

export const CCPAButton = () => {
  const geoData = (window as any).OneTrust?.getGeolocationData();
  const showCCPA = geoData?.state === 'CA';

  return showCCPA ? (
    <Button
      backgroundless={true}
      className="ot-sdk-show-settings"
      onClick={() => (window as any).OneTrust.ToggleInfoDisplay()}
    >
      {getCopy('buttons.ccpa')}
    </Button>
  ) : null;
};
